import React from 'react';
import { Link } from 'react-router-dom';
import type { Article } from '../types';
import OptimizedImage from './OptimizedImage';

interface ArticleCardProps {
    article: Article;
}

const ArticleCard: React.FC<ArticleCardProps> = ({ article }) => {
    const formattedDate = new Date(article.publishDate).toLocaleDateString('en-US', {
        year: 'numeric',
        month: 'long',
        day: 'numeric'
    });

    return (
        <Link 
            to={`/journal/${article.slug}`}
            className="group block"
        >
            <div className="overflow-hidden mb-4">
                 <OptimizedImage 
                    src={article.imageUrl} 
                    alt={article.title} 
                    size={800}
                    className="w-full h-64 object-cover grayscale group-hover:grayscale-0 group-hover:scale-105 transition-all duration-500 ease-in-out"
                />
            </div>
            <div className="flex items-center gap-2 text-xs uppercase tracking-widest text-gray-500 font-header">
                 <OptimizedImage 
                    src={article.author.avatarUrl}
                    size={200}
                    alt={article.author.name}
                    className="w-6 h-6 rounded-full object-cover"
                    fallbackSrc={`https://ui-avatars.com/api/?name=${encodeURIComponent(article.author.name)}&background=e5e7eb&color=4b5563&size=64`}
                 />
                 <span className="font-semibold">{article.author.name}</span>
                 <span>&bull;</span>
                 <span>{formattedDate}</span>
            </div>
            <h3 className="text-2xl font-semibold mt-2 group-hover:text-gray-600 transition-colors font-heading">{article.title}</h3>
            <p className="text-gray-600 mt-2 text-sm leading-relaxed font-body">{article.excerpt}</p>
            <div className="inline-block mt-4 text-sm font-semibold text-brand-dark relative after:content-[''] after:absolute after:left-0 after:bottom-[-2px] after:w-full after:h-[1px] after:bg-brand-dark after:scale-x-0 group-hover:after:scale-x-100 after:origin-left after:transition-transform font-header">
                Read More
            </div>
        </Link>
    );
};

export default ArticleCard;